// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { metalL2 as _metalL2 } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the metalL2 chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1750
 * Chain Name: Metal L2
 * Default Block Explorer: https://explorer.metall2.com
 * Default RPC URL: https://rpc.metall2.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { metalL2 } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: metalL2,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const metalL2 = createCommon({
	..._metalL2,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
